module.exports = __webpack_public_path__ + "static/media/logo-aspecir-negativo.9d7de512.png";